import { Navigate } from 'react-router-dom';
import { DashboardPage } from '../features/dashboard';
import { selectCurrentUser } from '../features/user';
import { useAppSelector } from '../store/hooks';
import { UserRole } from '../types';

/**
 * Protected route component for Dashboard
 * Only allows Supervisor, CSR, and Administrator roles
 * Redirects Dealers to order management
 */
const DashboardRoute = () => {
  const currentUser = useAppSelector(selectCurrentUser);

  if (!currentUser) {
    return <Navigate to="/" replace />;
  }

  // Allow Supervisor, CSR, and Administrator
  if (
    currentUser.role === UserRole.SUPERVISOR ||
    currentUser.role === UserRole.CSR ||
    currentUser.role === UserRole.ADMINISTRATOR
  ) {
    return <DashboardPage />;
  }

  // Redirect Dealers to order management
  if (currentUser.role === UserRole.DEALER) {
    return <Navigate to="/order-management" replace />;
  }

  // Default redirect for other roles
  return <Navigate to="/" replace />;
};

export default DashboardRoute;
